export const COUNTRY_CODES = [
  { code: "+91", label: "IN" },
  { code: "+1", label: "US" },
  { code: "+44", label: "UK" },
  { code: "+971", label: "AE" },
  { code: "+61", label: "AU" },
  { code: "+65", label: "SG" },
  { code: "+60", label: "MY" },
  { code: "+966", label: "SA" },
  { code: "+974", label: "QA" },
  { code: "+965", label: "KW" },
  { code: "+968", label: "OM" },
  { code: "+973", label: "BH" },
  { code: "+977", label: "NP" },
  { code: "+94", label: "LK" },
  { code: "+880", label: "BD" },
  { code: "+64", label: "NZ" },
  { code: "+49", label: "DE" },
  { code: "+33", label: "FR" },
  { code: "+39", label: "IT" },
  { code: "+34", label: "ES" },
  { code: "+27", label: "ZA" },
  { code: "+852", label: "HK" },
];

const DIAL_CODES = COUNTRY_CODES.map((c) => c.code).sort((a, b) => b.length - a.length);

export function parsePhone(value) {
  const v = (value || "").trim();
  for (const c of DIAL_CODES) {
    if (v.startsWith(c)) return { code: c, number: v.slice(c.length).trim() };
  }
  return { code: "+91", number: v };
}

export function PhoneInput({ value = "", onChange, testId, variant = "box", large = false, placeholder = "90000 00000", autoFocus }) {
  const { code, number } = parsePhone(value);
  const box = variant === "box";
  const emit = (c, n) => onChange(`${c} ${n}`.trim());

  const wrap = `flex items-stretch transition-colors ${box ? "bg-white border border-[#EAE7E0] focus-within:border-[#C88270]" : "border-b border-[#EAE7E0] focus-within:border-[#C88270]"}`;
  const sel = `bg-transparent text-[#2A2421] focus:outline-none cursor-pointer border-r border-[#EAE7E0] ${large ? "px-3 text-base" : box ? "px-2 py-2 text-sm" : "pr-2 py-2 text-sm"}`;
  const inp = `flex-1 min-w-0 bg-transparent text-[#2A2421] focus:outline-none ${large ? "px-4 py-3.5 text-base" : box ? "px-3 py-2 text-sm" : "px-3 py-2 text-sm"}`;

  return (
    <div className={wrap} data-testid={testId ? `${testId}-wrap` : undefined}>
      <select value={code} onChange={(e) => emit(e.target.value, number)} data-testid={testId ? `${testId}-code` : undefined} className={sel}>
        {COUNTRY_CODES.map((c) => <option key={c.code} value={c.code}>{c.label} {c.code}</option>)}
      </select>
      <input value={number} onChange={(e) => emit(code, e.target.value)} data-testid={testId} placeholder={placeholder} inputMode="tel" autoFocus={autoFocus} className={inp} />
    </div>
  );
}
